import React from "react";

import { HeaderBreadcrumb } from "../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../AdminRoutes";
import { DistributorListingProvider } from "./context/DistributorListingProvider";
import { DistributorsListing } from "./listing/DistributorsListing";

export const DistributorsDashboard: React.FC = () => {
    return (
        <DistributorListingProvider>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <DistributorsListing />
        </DistributorListingProvider>
    );
};
